import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { s as e } from "../FareInfographic.module-8nR033N7.js";
import { c as n } from "../clsx-OuTLNxxd.js";
import o from "react-loading-skeleton";
const m = _ref => {
    let {
      expandable: r,
      isExpanded: l = !1,
      variant: i = "default"
    } = _ref;
    const a = i == "full-horizontal" || l;
    return /* @__PURE__ */s("div", {
      className: n(e.container, {
        [e.variantDefault]: i == "default",
        [e.variantFullHorizontal]: i == "full-horizontal",
        [e.variantAlwaysVertical]: i == "always-vertical",
        [e.expandable]: r,
        [e.static]: !r,
        [e.isExpanded]: l,
        [e.isCollapsed]: !l
      }),
      children: /* @__PURE__ */c("ul", {
        className: e.groups,
        children: [/* @__PURE__ */s(t, {
          id: "pre-cruise",
          isExpanded: a
        }), /* @__PURE__ */s(t, {
          id: "cruise",
          isExpanded: a
        }), /* @__PURE__ */s(t, {
          id: "shorex",
          isExpanded: a
        }), /* @__PURE__ */s(t, {
          id: "post-cruise",
          isExpanded: a
        })]
      })
    });
  },
  t = _ref2 => {
    let {
      id: r,
      isExpanded: l
    } = _ref2;
    const i = l;
    return /* @__PURE__ */c("li", {
      className: n(e.group, {
        [e.isShorex]: r == "shorex",
        [e.isPreCruise]: r == "pre-cruise",
        [e.isPostCruise]: r == "post-cruise"
      }),
      children: [/* @__PURE__ */s("div", {
        className: e.groupHeaderIcon,
        children: /* @__PURE__ */s(o, {
          count: 1,
          height: 40,
          width: 40,
          circle: !0
        })
      }), /* @__PURE__ */s("div", {
        className: e.groupHeader,
        children: /* @__PURE__ */s(o, {
          count: 1,
          width: "80px"
        })
      }), i && /* @__PURE__ */c("ul", {
        className: e.steps,
        children: [/* @__PURE__ */s("li", {
          className: e.step,
          children: /* @__PURE__ */s(o, {
            count: 1,
            width: "80px"
          })
        }), /* @__PURE__ */s("li", {
          className: e.step,
          children: /* @__PURE__ */s(o, {
            count: 1,
            width: "80px"
          })
        })]
      })]
    }, r);
  };
export { m as FareInfographicSkeleton };